var map = {
  "./activity-empty.svg": "16873",
  "./add.svg": "76195",
  "./alert.svg": "70912",
  "./annotations.svg": "47352",
  "./answers-visible.svg": "97062",
  "./answers.svg": "15535",
  "./apps.svg": "62434",
  "./archive.svg": "28360",
  "./arrow-back.svg": "15455",
  "./arrow-double-down.svg": "93334",
  "./arrow-double-up.svg": "74285",
  "./arrow-down-bold.svg": "79022",
  "./arrow-down.svg": "84090",
  "./arrow-downward.svg": "16704",
  "./arrow-drop-down-circle.svg": "40067",
  "./arrow-drop-down.svg": "27174",
  "./arrow-forward.svg": "70009",
  "./arrow-left.svg": "59537",
  "./arrow-right.svg": "41756",
  "./arrow-up-bold.svg": "97935",
  "./arrow-up.svg": "92681",
  "./arrow-upward.svg": "99987",
  "./assignment.svg": "37901",
  "./attachment.svg": "21437",
  "./author.svg": "2911",
  "./auto-fix.svg": "90153",
  "./autorenew.svg": "17794",
  "./bar-chart.svg": "74858",
  "./bold.svg": "33647",
  "./bookmark.svg": "60574",
  "./calculator.svg": "24246",
  "./calender.svg": "43192",
  "./chapter-empty-two-layers.svg": "14951",
  "./chapter-empty.svg": "43653",
  "./checkmark-circle-fill.svg": "27080",
  "./checkmark-circle.svg": "62950",
  "./checkmark.svg": "98633",
  "./clock-progress.svg": "8780",
  "./code-braces.svg": "62954",
  "./code.svg": "97869",
  "./columns-2.svg": "24790",
  "./comment.svg": "98653",
  "./competencies.svg": "27457",
  "./content.svg": "60617",
  "./copy.svg": "20493",
  "./creation.svg": "93921",
  "./creative-commons.svg": "50176",
  "./cross-circle.svg": "44363",
  "./cross.svg": "20142",
  "./crown.svg": "57023",
  "./cursor.svg": "84656",
  "./dead.svg": "23256",
  "./decision-arrows.svg": "4679",
  "./desktop.svg": "47870",
  "./distribute-columns.svg": "44757",
  "./donut.svg": "27222",
  "./dot.svg": "64115",
  "./double-arrow.svg": "25689",
  "./draw.svg": "46044",
  "./ellipse-outline.svg": "88249",
  "./email.svg": "20506",
  "./enter.svg": "28036",
  "./entree-logo.svg": "1313",
  "./eraser.svg": "25946",
  "./excel.svg": "30447",
  "./exercises.svg": "88424",
  "./exit.svg": "66918",
  "./expand.svg": "6722",
  "./external-link.svg": "26924",
  "./eye-off.svg": "42085",
  "./eye.svg": "32017",
  "./feedback-filled.svg": "58940",
  "./feedback.svg": "71075",
  "./file-download.svg": "30653",
  "./file-upload.svg": "95818",
  "./file.svg": "47508",
  "./filter-list.svg": "57337",
  "./find-in-page.svg": "1791",
  "./flash-card.svg": "63859",
  "./folder.svg": "15958",
  "./formula.svg": "93556",
  "./fullscreen-exit.svg": "37586",
  "./fullscreen.svg": "26277",
  "./gift.svg": "39768",
  "./google-drive.svg": "74980",
  "./google-logo-color.svg": "69815",
  "./grid.svg": "40678",
  "./group-empty.svg": "92819",
  "./heading.svg": "57948",
  "./help-circle.svg": "7628",
  "./home.svg": "51079",
  "./horizontal-align-center.svg": "73804",
  "./hyperlink.svg": "8996",
  "./ideal.svg": "17025",
  "./image.svg": "16517",
  "./indent.svg": "33688",
  "./info-circle.svg": "97283",
  "./italic.svg": "19714",
  "./justify-center.svg": "23292",
  "./justify-left.svg": "21768",
  "./justify-right.svg": "91927",
  "./key.svg": "3475",
  "./keyboard.svg": "41589",
  "./last-modified.svg": "78362",
  "./layer-folder.svg": "83618",
  "./learnbeat-no-label.svg": "79761",
  "./learnbeat.svg": "39832",
  "./learning-text.svg": "87372",
  "./leswijs.svg": "70003",
  "./library.svg": "21615",
  "./lightbulb-filled.svg": "49472",
  "./lightbulb-off.svg": "34167",
  "./lightbulb.svg": "90143",
  "./line.svg": "12704",
  "./loading.svg": "91922",
  "./local-cafe.svg": "23523",
  "./lock-open.svg": "45240",
  "./lock.svg": "89399",
  "./magister-logo.svg": "17268",
  "./menu.svg": "11183",
  "./merge-layers.svg": "13757",
  "./messageFrom.svg": "90795",
  "./messageTo.svg": "60616",
  "./microphone.svg": "50178",
  "./minus.svg": "54986",
  "./module.svg": "70154",
  "./molsketch-benzene.svg": "36002",
  "./molsketch-bond-double.svg": "66350",
  "./molsketch-bond-single.svg": "80613",
  "./molsketch-bond-triple.svg": "56017",
  "./move.svg": "60221",
  "./notifications-active.svg": "6721",
  "./off.svg": "35933",
  "./office365-logo-color.svg": "41212",
  "./one-column.svg": "44885",
  "./orderedlist.svg": "18209",
  "./outdent.svg": "46673",
  "./palette.svg": "53687",
  "./pause.svg": "23860",
  "./pen.svg": "51247",
  "./pencil.svg": "661",
  "./people-plus.svg": "2868",
  "./people.svg": "73643",
  "./periodic-table.svg": "79614",
  "./person-add.svg": "56639",
  "./person.svg": "88845",
  "./phone.svg": "35374",
  "./photo-library.svg": "11584",
  "./planner.svg": "44194",
  "./play-circle.svg": "85801",
  "./play.svg": "51420",
  "./plus-circle-filled.svg": "14672",
  "./plus-circle.svg": "89455",
  "./portfolio.svg": "47878",
  "./present.svg": "61639",
  "./presentation.svg": "38162",
  "./print.svg": "83839",
  "./progress.svg": "47591",
  "./qrcode.svg": "15800",
  "./queue.svg": "66191",
  "./quote-round.svg": "1989",
  "./quote.svg": "65482",
  "./rect-outline.svg": "24337",
  "./redo-arrow.svg": "5634",
  "./refresh.svg": "84739",
  "./reorder.svg": "73099",
  "./restart.svg": "29967",
  "./results.svg": "22440",
  "./school-building.svg": "6963",
  "./school.svg": "77106",
  "./search.svg": "21654",
  "./section-empty.svg": "6443",
  "./select-copy.svg": "54276",
  "./select-delete.svg": "71846",
  "./send.svg": "59776",
  "./server-saved.svg": "49025",
  "./server-syncing.svg": "21471",
  "./server-unsaved.svg": "7506",
  "./settings.svg": "67973",
  "./share-with-school.svg": "10669",
  "./share.svg": "99299",
  "./show.svg": "52405",
  "./shuffle.svg": "79289",
  "./sign-direction.svg": "66537",
  "./skip-next.svg": "50031",
  "./smartphone.svg": "38847",
  "./somtoday-color.svg": "76614",
  "./source-12.svg": "64511",
  "./source-13.svg": "36078",
  "./source-14.svg": "34577",
  "./source-4.svg": "23442",
  "./source-6.svg": "81040",
  "./source-7.svg": "16577",
  "./source-minus-1.svg": "91972",
  "./spinner.svg": "59337",
  "./stack.svg": "70942",
  "./star-rounded.svg": "20678",
  "./stop-circle.svg": "61827",
  "./stop.svg": "19174",
  "./subscript.svg": "21457",
  "./superscript.svg": "62330",
  "./support.svg": "42603",
  "./surf-logo-black.svg": "35932",
  "./swap-arrows.svg": "18498",
  "./swap.svg": "80127",
  "./symbol.svg": "2238",
  "./tab.svg": "60555",
  "./table.svg": "6882",
  "./tag.svg": "58438",
  "./take-in.svg": "42257",
  "./task-1.svg": "7455",
  "./task-11.svg": "63420",
  "./task-16.svg": "33603",
  "./task-2.svg": "28428",
  "./task-22.svg": "62230",
  "./task-25.svg": "53817",
  "./task-26.svg": "93066",
  "./task-28.svg": "59644",
  "./task-29.svg": "30269",
  "./task-30.svg": "44791",
  "./task-31.svg": "57254",
  "./task-32.svg": "72741",
  "./task-33.svg": "1668",
  "./task-34.svg": "63819",
  "./task-35.svg": "61114",
  "./task-36.svg": "59849",
  "./task-39.svg": "23118",
  "./task-40.svg": "83006",
  "./task-6.svg": "94432",
  "./template.svg": "82068",
  "./text.svg": "14515",
  "./theory.svg": "42129",
  "./three-dots.svg": "89179",
  "./time.svg": "45873",
  "./timer.svg": "53041",
  "./training-empty.svg": "36444",
  "./translate.svg": "56080",
  "./trash.svg": "19960",
  "./trend-down.svg": "90436",
  "./trend-stable.svg": "29225",
  "./trend-up.svg": "82559",
  "./trophy.svg": "9404",
  "./two-columns.svg": "72110",
  "./two-rotating-arrows.svg": "15968",
  "./underline.svg": "4018",
  "./undo-arrow.svg": "15700",
  "./unorderedlist.svg": "14266",
  "./update.svg": "41289",
  "./user-clock.svg": "19226",
  "./volume-up.svg": "72170",
  "./warning-fill.svg": "31284",
  "./warning.svg": "41242",
  "./words-menu.svg": "32435",
  "./zoom-in.svg": "29233",
  "./zoom-out.svg": "23072"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 81487;
